export const SLIDE_THUMBNAIL_MODE = 'thumbnail'
